import React, { Component } from 'react'
import { replaceWith } from '../navigation'

export default class NoMatch extends Component {
  componentDidMount() {
    replaceWith('/')
  }

  render() {
    return(
      <></>
    )
  }
}